import { Button } from 'antd';

import { trackButtonClick } from '../../analytics/mixpanel';
import InlineStyled from '../../CommonComponents/InlineStyled/InlineStyled';

const PresetResponseBox = ({ data, handleExportPresets, presets, disabled }) => {
  const exportHandler = () => {
    trackButtonClick({ type: 'Export xlsx - preset' });
    const preset = presets.find((p) => p.preset_id === data.preset_id);
    handleExportPresets({
      export_format: 'xlsx',
      preset_id: data.preset_id,
      fileNameSuffix: ` - ${preset.preset_name}`,
      run_id: data.run_id,
      data,
    });
  };

  return (
    <div>
      {/* fully successful */}
      {data.successfulDocuments.length > 0 && data.failedDocuments.length === 0 && (
        <>
          <InlineStyled
            $style={{
              color: '#27374A',
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Your analysis is ready.
          </InlineStyled>
          <InlineStyled $style={{ marginTop: 10 }}>
            <InlineStyled
              as={Button}
              $style={{ padding: 0 }}
              type='link'
              onClick={exportHandler}
              disabled={disabled}
            >
              Click here
            </InlineStyled>{' '}
            to view the analysis of all documents.
          </InlineStyled>
        </>
      )}
      {/* partial success */}
      {data.successfulDocuments.length > 0 && data.failedDocuments.length > 0 && (
        <>
          <InlineStyled
            $style={{
              color: '#27374A',
              fontSize: 14,
              fontWeight: 600,
            }}
          >
            Analysis of {data.successfulDocuments.length} of{' '}
            {data.successfulDocuments.length + data.failedDocuments.length} documents is completed.
          </InlineStyled>
          <InlineStyled
            $style={{
              color: '#27374A',
              fontSize: 14,
            }}
          >
            We were not able to process the following documents -
          </InlineStyled>
          {data?.failedDocuments?.map((v, i) => (
            <InlineStyled
              key={v.documentID}
              $style={{
                color: '#27374A',
                fontSize: 14,
                fontWeight: 600,
                marginLeft: 20,
              }}
            >
              {i + 1}. {v.documentName}
            </InlineStyled>
          ))}
          <InlineStyled $style={{ marginTop: 10 }}>
            <InlineStyled
              as={Button}
              $style={{ padding: 0 }}
              type='link'
              onClick={exportHandler}
              disabled={disabled}
            >
              Click here
            </InlineStyled>{' '}
            to view the analysis for completed documents
          </InlineStyled>
        </>
      )}

      {/* fully failed */}
      {data.successfulDocuments.length === 0 && data.failedDocuments.length > 0 && (
        <InlineStyled
          $style={{
            color: '#27374A',
            fontSize: 14,
          }}
        >
          We were not able to complete the analysis of selected documents. Please try again.
          <br />
          <br />
          If the problem persists then reach out to our co-founders Tushar (tushar@mikelegal.com) or
          Anshul (anshul@mikelegal.com).
        </InlineStyled>
      )}
    </div>
  );
};

export default PresetResponseBox;
